<template>
  <div>
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <div class="d-inline-block" style="width:160px">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
    </v-app-bar>
    <v-row style="height:64px; width:100%">
    </v-row>
    <v-row class="ma-5">
      <v-btn  class="ma-0 pa-0" outlined style="width:130px; height:40px; background:#FFF; border-radius:8px; border: 1px solid #969698" @click="redirectPath('/login')">
        <v-icon style="color:#969698">mdi-arrow-left-bold-circle-outline</v-icon>
        <span class="px-1" style="font-size:13pt; color:#969698">回登入頁</span>
      </v-btn>
    </v-row>
    <v-card color="#FFF" style="box-shadow:none; overflow-x:hidden; overflow-y:scroll" align="center" :style="viewStyle">
      <v-row class="ma-0" justify="center">
        <v-col class="pb-0 col-10 col-sm-9 col-md-8 col-lg-5" align="right">
          <div id="box2" class="my-2 pa-5 py-10" style="min-height:540px">
            <v-row style="margin-top:3%; margin-left:3%">
              <div class="mx-5 firstBar"></div>
              <h4 style="font-size:26px">證書驗證資訊</h4>
            </v-row>
            <v-row>
              <v-col class="col-9 col-sm-9 col-md-9 col-lg-9">
                <v-row class="mt-2" justify="center">
                  <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-10">
                    <div class="text-left pt-2 pt14"><span class="start">*</span>考生中文名</div>
                    <v-text-field class="mt-2 border pt14" dense background-color="white" outlined placeholder="請輸入考生中文名" v-model="data.name"></v-text-field>
                    <div class="text-left pt-2 pt14"><span class="start">*</span>考生身分證</div>
                    <v-text-field class="mt-2 border pt14" dense background-color="white" outlined placeholder="請輸入考生身分證" v-model="data.idCard"></v-text-field>
                    <div class="text-left pt-2 pt14"><span class="start">*</span>發證年月</div>
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y left min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field dense outlined background-color="white" readonly class="text_field datePicker" placeholder="請選擇發證年月"
                          v-model="data.examDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                        </v-text-field>
                      </template>
                      <v-date-picker type="month" ref="picker" v-model="data.examDate" no-title scrollable
                        :max="new Date().toISOString().substr(0, 10)" @change="$refs.menu.save(data.examDate)"
                      ></v-date-picker>
                    </v-menu>
                    <!-- <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field dense outlined background-color="white" readonly class="text_field" placeholder="請選擇發證年月"
                          v-model="data.examDate" append-icon="icon-plan_calendar" v-bind="attrs" v-on="on">
                        </v-text-field>
                      </template>
                      <v-date-picker type="month" v-model="data.examDate" no-title scrollable></v-date-picker>
                    </v-menu> -->
                    <div class="text-left pt-2 pt14"><span class="start">*</span>證書編號</div>
                    <v-text-field class="mt-2 border pt14" dense background-color="white" outlined placeholder="請輸入證書編號" v-model="data.certNo"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-2 col-sm-2 col-md-2 col-lg-2">
                <v-row class="mt-2" align="center" style="height:100%">
                  <div class="loginBtn centerBtn" style="height:60%; width:90%; cursor: pointer" @click="verify()">
                    <div style="color:#FFFFFF"><h3>進行</h3><h3>驗證</h3></div>
                  </div>
                </v-row> 
              </v-col>
            </v-row>
            <v-row class="mt-2" justify="center">
              <h5 class="start">- 本驗證功能僅能查閱2024年2月起始的證書資料 -</h5>
            </v-row>
          </div>
        </v-col>
        <v-col v-if="verifyView" class="col-10 col-sm-9 col-md-8 col-lg-4" align="center">
          <div id="box2" class="my-2 pa-5 py-10" style="min-height:540px">
            <v-row style="margin-top:3%; margin-left:3%">
              <div class="mx-5 firstBar"></div>
              <h4 style="font-size:26px">證書驗證資訊</h4>
            </v-row>
            <v-row style="margin:4%">
              <v-col v-if="!haveData" class="py-0">
                <div class="text-left pt-2 start">查無相關資料 !</div>
              </v-col>
              <v-col v-if="haveData" class="py-0">
                <div class="text-left pt-2 pt14">考生中文名： {{datasets.name}}</div>
                <div class="text-left pt-2 pt14">證照等級英文： {{datasets.engName1}}</div>
                <div class="text-left pt-2 pt14">證照類型英文： {{datasets.engName2}}</div>
                <div class="text-left pt-2 pt14">認證模組英文： {{datasets.engName3}}</div>
                <div class="text-left pt-2 pt14">認證廠商與版本英文： {{datasets.engName4}}</div>
                <div class="text-left pt-2 pt14">證照類型中文： {{datasets.class1}}</div>
                <div class="text-left pt-2 pt14">認證模組中文： {{datasets.class2}}</div>
                <div class="text-left pt-2 pt14">認證廠商與版本中文： {{datasets.class3}}</div>
                <div class="text-left pt-2 pt14">發證年月： {{datasets.examDateMonth}}, {{datasets.examDateYear}}</div>
                <div class="text-left pt-2 pt14">證書編號： {{datasets.certNo}}</div>
              </v-col>
            </v-row>
            <v-row v-if="haveData" justify="center" style="margin:6% 6% 0% 6%; border-top: 2px solid #939C99">
              <h5 class="mt-3" style="color:#939C99">請核對紙本證書資訊</h5>
            </v-row>
          </div>

        </v-col>
      </v-row>
      <div class="pt-3 pb-10 col-10">
        <h4 style="font-size:12px">中華企業資源規劃學會 版權所有，禁止未經授權轉貼節錄</h4>
        <h4 style="font-size:12px"> 2009 中華企業資源規劃學會．Chinese Enterprise Resource Planning Society.</h4>
        <h4 style="font-size:12px">校址：(32001)桃園市中壢區中大路300號 管理學院二館6F Tel：(03)426-4248 Fax：(03)426-0076</h4>
      </div>
    </v-card>
    <ShowMsg ref="ShowMsg" />
  </div>
</template>
<script>

import CryptoJS from "crypto-js"
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'CertificateVerification',
  components: {ShowMsg},
  data:()=>({
    datasets: {},
    viewStyle:{},
    images:{
      new_logo: require('@/assets/image/erp_logo.png'),
    },
    indexHover:0,
    indexHover1:0,
    remeberMe:false,
    isError:true,
    data:{
      name:'',
      idCard:'',
      examDate:'',
      examDateYear:'',
      examDateMonth:'',
      certNo:'',
    },
    pickerDate: '2022-01-01',
    menu: false,
    date: null,
    verifyView:false,
    haveData:false,
    requiredField:['name','idCard','examDate','certNo'],
  }),
  mounted(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    menu (val) {
      val && setTimeout(() => (
        this.$refs.picker.activePicker = 'month',
        this.pickerDate = null
      ))
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-144 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    verify(){
      if(!this.$Global.checkForm(this.data,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      // examDate 以'-'區分，examDateYear - examDateMonth
      let examDateS = this.data.examDate.split('-')
      this.data.examDateYear = examDateS[0]
      this.data.examDateMonth = examDateS[1]

      var self = this
      var request = {
        method: 'POST',
        url: '/common/checkCertificate',
        params: {
          name: self.data.name,
          idCard: self.data.idCard,
          examDateMonth: self.data.examDateMonth,
          examDateYear: self.data.examDateYear,
          certNo:  self.data.certNo,
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Cvn-7956')
      }).finally(()=>{
      self.verifyView = true
      if(self.datasets.name){
        self.haveData = true
      } else {
        self.haveData = false
      }
      })
    }
  }
}
</script>
